import { defineMessages } from 'react-intl';

const upgradeOverviewMessages = defineMessages({
  featureName: {
    id: 'unlock.overview',
    defaultMessage: 'Overview',
  },
  featureHeading: {
    id: 'unlock.overview.heading',
    defaultMessage: 'Unlock Overview',
  },
  featureSummary: {
    id: 'unlock.overview.summary',
    defaultMessage: 'You\'ll get right to work faster',
  },
  featureUnlockDetails: {
    id: 'unlock.overview.details',
    // eslint-disable-next-line max-len
    defaultMessage: 'The <strong>Overview</strong> provides a summary of your scheduled visits and fairs for the week with easy access to appointment details—all in one quick view.',
  },
});

export default upgradeOverviewMessages;
